import posthog from 'posthog-js';
import { config } from './config.js';

/** @import {PostHogConfig} from 'posthog-js' */

/**
 * Initializes the PostHog analytics library for tracking user interactions.
 */
export function initPostHog() {
  /** @type {Partial<PostHogConfig>} */
  const postHogConfig = {
    api_host: 'https://bees.katapultpro.com',
    defaults: '2026-01-30',
    opt_out_capturing_by_default: true
  };

  // Initialize PostHog
  posthog.init(config.postHogApiKey, postHogConfig);

  console.log('PostHog initialized');
}
